module.exports = __webpack_public_path__ + "static/img/sy.90ee603d.png";